import { render, staticRenderFns } from "./CourseAssignLessons.vue?vue&type=template&id=65dc41fa&scoped=true&"
import script from "./CourseAssignLessons.vue?vue&type=script&lang=js&"
export * from "./CourseAssignLessons.vue?vue&type=script&lang=js&"
import style0 from "./CourseAssignLessons.vue?vue&type=style&index=0&id=65dc41fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc41fa",
  null
  
)

export default component.exports